import React from 'react';
import styled from "styled-components";
import {motion} from "framer-motion";

function Login(props) {
    return (
        <Container>
            <Content>
                <CTA>
                    <CTALogoOne as={motion.img}
                        src = "./images/cta-logo-one.svg" alt="logo-1"
                        initial={{opacity: 0, y: -100}}
                        whileInView={{opacity: 1, y: 0}}
                        // animate={{ opacity: 1 }}
                        transition={{ duration: 3, delay:1 }}
                    />
                    <SignUp as={motion.a}
                        initial={{opacity: 0}}
                            whileInView={{opacity:1}}
                            transition={{duration: 4}}
                    >get it all there</SignUp>
                    <Description as={motion.p}
                         initial={{opacity: 0}}
                         whileInView={{opacity: 1}}
                         transition={{delay: 1, duration:3}}
                    >
                        Get Premier Access to Raya and the Last Dragon for an additional fee
                        with a Disney+ subscription. As of 03/26/21, the price of Disney+
                        and The Disney Bundle will increase by $1.
                    </Description>
                    <CTALogoTwo as={motion.img}
                                src = "./images/cta-logo-two.png"
                                alt="logo-2"
                                initial={{opacity: 0, y: 100}}
                                whileInView={{opacity: 1, y: 0}}
                        // animate={{ opacity: 1 }}
                                transition={{ duration: 3, delay:1 }}
                    />

                </CTA>
                <BgImage></BgImage>
            </Content>
        </Container>

    );
}

const Container = styled.section`
    display: flex;
    overflow: hidden;
    flex-direction: column;
    text-align: center;
    height: 100vh;
`

const Content = styled.div`
    box-sizing: border-box;
    position: relative;
    margin-bottom: 10vw;
    padding: 80px 40px;
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    opacity: 1;
    transition: opacity 0.7s ease-out;
`

const BgImage = styled.div`
    width: 100%;
    height: 100%;
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url('./images/login-background.jpg');
    position: absolute;
    top: 0;
    right: 0;
    z-index: -1;
`

const CTA = styled.div`
    margin-bottom: 2vw;
    // margin-bottom: 0;
    max-width: 650px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
`
const CTALogoOne = styled.img`
    margin-bottom: 12px;
    max-width: 600px;
    min-height: 1px;
    width: 100%;
    display: block;
    opacity: 0;
    position: relative;
    // top: -100px;
`

const SignUp = styled.a`
    width: 100%;
    max-width: 650px;
    font-weight: bold;
    font-size: 18px;
    letter-spacing: 1.5px;
    color: #f9f9f9;
    background-color: #0063e5;
    margin-bottom: 12px;
    padding: 16.5px 0;
    border-radius: 4px;
    text-transform: uppercase;
    border: 1px solid transparent;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    &:hover{
        background-color: #0483ee;
        transform: scaleX(1.02);
    }
`

const Description = styled.p`
    color: hsla(0, 0%, 95.3%, 1);
    font-size: 12px;
    margin: 0 0 24px;
    line-height: 1.5;
    letter-spacing: 1px;
`

const CTALogoTwo = styled.img`
    display: inline-block;
    width: 100%;
    max-width: 600px;
    margin-bottom: 20px;
`

export default Login;